import {
    FormControl,
    FormGroup,
    ControlLabel,
    Radio,
    Button,
    OverlayTrigger,
    Tooltip
} from 'react-bootstrap';
import { connect } from 'react-redux';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as actions from '../../../actions/adminActions';
import { copy } from '../../../users/constants';

class NewUser extends Component {
    constructor(props) {
        super(props);
        const { data } = this.props;
        const isAdmin = data.userType === 'underwriter' ? 'false' : 'true';

        this.state = {
            isAdmin,
            email: ''
        };

        this.onChangeAdmin = this.onChangeAdmin.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.submitNewUser = this.submitNewUser.bind(this);
    }

    onChangeAdmin(event) {
        this.setState({
            ...this.state,
            isAdmin: event.target.value
        });
    }

    onChangeEmail(event) {
        this.setState({
            ...this.state,
            email: event.target.value
        });
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.admin &&
            nextProps.admin.alertDisplay &&
            nextProps.admin.alertDisplay.bsStyle === 'success'
        ) {
            this.setState({
                ...this.state,
                email: '',
                isAdmin: 'false'
            });
        }
    }

    submitNewUser(event) {
        event.preventDefault();
        this.props.handleCreateUser(this.state.email, this.state.isAdmin);
    }

    render() {
        const { data } = this.props;
        const toolTipLabel =
            data.userType === 'underwriter'
                ? copy.lang('underwritersInviteGroupTooltip')
                : copy.lang('brokersInviteGroupTooltip', {
                      brokerageName: data.brokerName
                  });
        const title = data.userType === 'underwriter' ? 'Invite underwriter' : 'Invite broker';

        const tooltip = (
            <Tooltip id="adminSelectTooltip">
                <span>{toolTipLabel}</span>
            </Tooltip>
        );

        return (
            <div className="newUserComponent">
                <h1>{title}</h1>
                <p>
                    Team members will be able to create, edit, and view submissions for{' '}
                    {data.brokerName}
                </p>
                <form onSubmit={this.submitNewUser}>
                    <FormGroup controlId="newUserEmail">
                        <ControlLabel>Email</ControlLabel>
                        <FormControl
                            type="email"
                            className="adminInput"
                            required
                            onChange={this.onChangeEmail}
                            value={this.state.email}
                            className="emailInput"
                        />
                    </FormGroup>
                    {data.userType === 'underwriter' && (
                        <FormGroup>
                            <ControlLabel>
                                Make admin?
                                <OverlayTrigger placement="right" overlay={tooltip}>
                                    <span className="tooltip-icon" />
                                </OverlayTrigger>
                            </ControlLabel>
                            <br />
                            <Radio
                                name="radioGroup"
                                className="adminInput"
                                inline
                                required
                                onChange={this.onChangeAdmin}
                                value={'true'}
                                checked={this.state.isAdmin === 'true'}
                            >
                                Yes
                            </Radio>{' '}
                            <Radio
                                name="radioGroup"
                                className="adminInput"
                                inline
                                required
                                onChange={this.onChangeAdmin}
                                value={'false'}
                                checked={this.state.isAdmin === 'false'}
                            >
                                No
                            </Radio>
                        </FormGroup>
                    )}

                    <Button type="submit">Send Invite</Button>
                </form>
            </div>
        );
    }
}

NewUser.propTypes = {
    data: PropTypes.object,
    handleCreateUser: PropTypes.func.isRequired,
    user: PropTypes.object,
    admin: PropTypes.object
};

export default connect(store => {
    return {
        user: store.user,
        admin: store.admin
    };
}, actions)(NewUser);
